import { Component,ElementRef, HostListener, OnInit } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  //enrolText:string = "To enrol, please speak to your healthcare professional.";
  close: string = "Close";
  enrollmenth3: string = "Enrolment";
  enrollmentp: string = "After a fast and easy enrolment, a Nurse Case Manager will call you to onboard you and walk you through the next steps.";
  enrollmentpath: string = "/assets/img/enrollment_box_icon.svg"

  ordersuupliesh3: string = "Ordering Supplies";
  ordersuupliesp: string = "You’ll get help with ordering ancillary supplies online and setting up delivery.";
  ordersuupliespath: string = "/assets/img/ordering_supplies_box-icon.svg";

  productcoorh3: string = "Product Coordination";
  productcoorp: string = "Your Nurse Case Manager will schedule your product pick-up with the blood bank or pharmacy.";
  productcoorpath: string = "/assets/img/product_coordination_box_icon.svg";

  trainingsuph3: string = "Training and Support";
  trainingsupp: string = "You’ll receive ongoing, personalized support throughout the course of your therapy from our team of Registered Nurses, with unlimited, one-to-one in-home or in-clinic training on how to self-administer treatment.";
  trainingsuppath: string = "/assets/img/training_box_icon.svg";

  physicianh3: string = "Reports to Physician and Healthcare Team";
  physicianp: string = "Our team will send summary notes to your physician at every touchpoint to ensure consistent support.";
  physicianpath: string = "/assets/img/reports_box_icon.svg";

  enrollment: boolean = false;
  orderingsupplies: boolean = false;
  productcoordination: boolean = false;
  trainingsupport: boolean = false;
  reportstophysician: boolean = false;
  height: any;
scrollBottom: any;
@HostListener('window:scroll', ['$event.target'])
onscroll(e:any)  {
    this.scrollBottom = e.scrollingElement.scrollTop;
    this.checkHeightToAnimate();
  }
  constructor(private elementRef: ElementRef) { }

  ngOnInit() {
  }

  checkHeightToAnimate() {
    try {
      if (this.checkScrollHeightBottom(this.scrollBottom,(this.elementRef.nativeElement.querySelector('#HCPS').offsetTop)))
        this.elementRef.nativeElement.querySelector('#hcp-support-image').classList.add('pre-animate');
      if (this.checkScrollHeightBottom(this.scrollBottom,(this.elementRef.nativeElement.querySelector('#sec_cslnews').offsetTop-500))){
        this.elementRef.nativeElement.querySelector('.csl_news').classList.add('pre-animate');
        setTimeout(() => {
          this.elementRef.nativeElement.querySelectorAll('.csl_news').forEach(element => {
            element.classList.add('display_news_img');
          })
        }, 200);
      }
    } catch (e) {}
}
  checkScrollHeightBottom(x: any, y: any) {
    if (x >= (y+200))
        return true;
    else
        return false;
}
  showpopup(id: string) {
    if (id == 'reportstophysician') {
      this.reportstophysician = true;
      this.enrollment = false;
      this.productcoordination = false;
      this.orderingsupplies = false;
      this.trainingsupport = false;
    }
    else if (id == 'enrollment') {
      this.reportstophysician = false;
      this.enrollment = true;
      this.productcoordination = false;
      this.orderingsupplies = false;
      this.trainingsupport = false;
    }
    else if (id == 'productcoordination') {
      this.reportstophysician = false;
      this.enrollment = false;
      this.productcoordination = true;
      this.orderingsupplies = false;
      this.trainingsupport = false;
    }
    else if (id == 'orderingsupplies') {
      this.reportstophysician = false;
      this.enrollment = false;
      this.productcoordination = false;
      this.orderingsupplies = true;
      this.trainingsupport = false;
    }
    else if (id == 'trainingsupport') {
      this.reportstophysician = false;
      this.enrollment = false;
      this.productcoordination = false;
      this.orderingsupplies = false;
      this.trainingsupport = true;
    }
  }

  popupclose() {
    this.reportstophysician = false;
    this.enrollment = false;
    this.productcoordination = false;
    this.orderingsupplies = false;
    this.trainingsupport = false;
  }
  // enrolTextOn(){
  //   this.enrolText = "To register, please speak to your healthcare professional."
  // }
  // enrolTextOff(){
  //   this.enrolText = "To enrol, please speak to your healthcare professional."
  // }

}
